module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section section-white content-padded"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "f_l member-info"
  }, [_vm._l((_vm.setting), function(item, key) {
    return [(key == 'habbit') ? _c('div', {
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((_vm.member[key]), function(row) {
      return (_vm.member[key]) ? _c('span', [_vm._v(_vm._s(row))]) : _c('span', [_vm._v("--")])
    })], 2) : _vm._e(), _vm._v(" "), (key == 'sex') ? _c('div', {
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.member[key] == 0) ? _c('span', [_vm._v("未知")]) : _vm._e(), _vm._v(" "), (_vm.member[key] == 1) ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.member[key] == 2) ? _c('span', [_vm._v("女")]) : _c('span', [_vm._v("--")])]) : _vm._e(), _vm._v(" "), (key != 'content_agreement' && key != 'habbit' && key != 'sex') ? _c('div', {
      staticClass: "info-item"
    }, [_c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.member[key]) ? _c('span', [_vm._v(_vm._s(_vm.member[key]))]) : _c('span', [_vm._v("--")])]) : _vm._e()]
  })], 2)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3dccb9f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dccb9f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/members/memberinfo.vue
// module id = 2645
// module chunks = 0